/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Spinner,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import { BASE_URL } from "../utils/constants";
import { MDBDataTableV5 } from "mdbreact";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";

const Interventions = () => {
  const permissions = useSelector((state) => state.permissions),
    [descModal, setDescModal] = useState(false),
    [interventions, setInterventions] = useState([]),
    [intervention, setIntervention] = useState({}),
    [intData, setIntData] = useState({
      columns: [
        {
          label: "#",
          field: "id",
        },
        {
          label: "Teacher",
          field: "teacher",
        },
        {
          label: "Date",
          field: "rdate",
        },
        {
          label: "Details",
          field: "details",
        },
      ],
      rows: [
        {
          id: <Spinner color="info" />,
          teacher: <Spinner color="info" />,
          rdate: <Spinner color="info" />,
          details: <></>,
        },
      ],
    });

  useEffect(async () => {
    Swal.showLoading();
    try {
      // waiting for interventions api to get data>>
      let res = await axios.get(`${BASE_URL}/student/getinterventions.php`);
      
      setInterventions(res.data.data);
      setIntData((prevState) => {
        const newState = { ...prevState };
        let ser = 1;
        // change .exams below to .homeworks and quiz to hmwork after backend finished
        let newRows = res.data.data.map((i, key) => {
          return {
            ...i,
            id: ser++,
            teacher: i.teachername,
            rdate: i.date,
            details: (
              <>
                <button
                  className="btn btn-info text-center fs-6 fw-bold py-1 px-3"
                  onClick={(e) => handleDescModal(e, i)}
                >
                  View
                </button>
              </>
            ),
          };
        });
        return { ...newState, rows: newRows };
      });
    } catch {
      Swal.fire("Something Went Wrong", "", "error");
    } finally {
      Swal.close();
    }
  }, []);

  const handleDescModal = async (e, obj) => {
    await setIntervention(obj);
    setDescModal(true);
  };

  const sectionContent = (html) => {
    if (!html) return <span>-</span>;
    return <div dangerouslySetInnerHTML={{ __html: html }}></div>;
  };

  const DetailItem = ({ label, value }) => (
    <Col md={6} className="mb-3">
      <div className="border rounded p-3 h-100 bg-light">
        <div className="text-muted small fw-bold mb-1">{label}</div>
        <div className="fw-bold">{value || "-"}</div>
      </div>
    </Col>
  );

  const DetailSection = ({ label, children }) => (
    <Col md={12} className="mb-3">
      <div className="border rounded p-3 bg-light">
        <div className="text-muted small fw-bold mb-2">{label}</div>
        {children}
      </div>
    </Col>
  );

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card className="w-100">
              <CardHeader>
                <h4 className="title">Behavioral Interventions</h4>
              </CardHeader>
              <CardBody className="all-icons">
                <MDBDataTableV5
                  hover
                  responsive
                  borderless={false}
                  bordered
                  striped
                  entriesOptions={[5, 20, 25]}
                  entries={5}
                  pagesAmount={4}
                  data={intData}
                  fullPagination
                  searchTop
                  searchBottom={false}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Description Modal */}
      <Modal
        isOpen={descModal}
        size="fullscreen"
        className="custom-modal-style"
      >
        <ModalHeader className="bg-info fw-bolder">
          Intervention Details
        </ModalHeader>
        <ModalBody>
          <Row>
            <DetailItem label="Teacher" value={intervention.teachername} />
            <DetailItem label="Date" value={intervention.date} />
            <DetailSection label="Description">
              {sectionContent(intervention.description)}
            </DetailSection>
          </Row>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-secondary"
            onClick={() => setDescModal(false)}
          >
            Close
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Interventions;
